import React from 'react';

export default function IconBandar() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={26}
      height={26}
      fill="none"
    >
      <path fill="none" d="M0 0h26v26H0z" />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M3.623 11.69h18.703M18.5 22.633c.757 0 1.497-.233 2.126-.671a3.953 3.953 0 0 0 1.409-1.788c.29-.728.365-1.53.217-2.302a4.038 4.038 0 0 0-1.046-2.04 3.78 3.78 0 0 0-1.959-1.09 3.684 3.684 0 0 0-2.21.226 3.864 3.864 0 0 0-1.717 1.467 4.104 4.104 0 0 0-.644 2.214c-.001.523.097 1.042.29 1.526.191.484.473.923.828 1.293.355.37.777.664 1.242.864.464.2.962.302 1.465.301v0ZM7.448 22.633c.757 0 1.496-.233 2.125-.671a3.954 3.954 0 0 0 1.409-1.788 4.14 4.14 0 0 0 .218-2.302 4.038 4.038 0 0 0-1.047-2.04 3.78 3.78 0 0 0-1.959-1.09 3.684 3.684 0 0 0-2.21.226 3.864 3.864 0 0 0-1.716 1.467 4.104 4.104 0 0 0-.645 2.214 4.07 4.07 0 0 0 1.12 2.817 3.75 3.75 0 0 0 2.705 1.167ZM11.273 18.648h3.404M18.965 4.805a1.511 1.511 0 0 0-.506-.843 1.405 1.405 0 0 0-.9-.329H8.418c-.327 0-.645.116-.9.33-.256.212-.434.51-.506.842L5.535 11.69h14.878l-1.448-6.885Z"
      />
    </svg>
  );
}
